import React from 'react';
import { NavLink } from "react-router-dom";

const NavigationItem = (props) => {

	const {
		itemClass,
		link,
		linkClass,
		linkText,
		alt,
		children,
		onClick
	} = props;

	return (
		<li className={'navigationItem' + (itemClass ? ' ' + itemClass : '')}>
			<NavLink to={link} exact activeClassName='active' title={alt} aria-label={alt} onClick={onClick} className={linkClass}>{linkText}</NavLink>
			{children}
		</li>
	);
};

export default NavigationItem;
